import React, { Component, createRef } from "react";
import Modal from "react-modal";
import firebase, { auth } from "firebase";
import Alert from "react-s-alert";
import secondaryApp from "../BD/secondaryApp";
import store from "../../store";
import Modal_Upload_Data from "../carga_empleados/modal_upload_data";
import * as XLSX from "xlsx";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

const database = firebase.database();

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    width: "450px",
    height: "550px",
  },
};

class Modal_empleados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      isActive: false,
      nodo: props.nodo,
      isActiveCosto: false,
      nom: "",
      Costos: [],
      codCosto: "",
      empresaUID: "",
      isOpen: false,
      isModalOpenUpload: false,
      authUser: null,
    };
    this.dropdownRef = createRef();
    this.empleados = this.props.empleadosData;

    this.empleadosColect = database
      .ref()
      .child("Clientes")
      .orderByChild("socio")
      .equalTo(this.props.socio);

    this.handleClick = this.handleClick.bind(this);
    this.insertRow = this.insertRow.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleModalUpload = this.toggleModalUpload.bind(this);
    this.handleKeyPressNumeros = this.handleKeyPressNumeros.bind(this);
    this.handleKeyPressDui = this.handleKeyPressDui.bind(this);
    this.empresaRef = database.ref().child("Empresa");
    this.empleadosRef = database.ref().child("empleado_empresa");
    this.clientesRef = database.ref().child("Clientes");
    this.costosRef = database.ref().child("CentroCosto");
  }

  handleClick() {}

  toggleModal() {
    this.setState({
      isActive: !this.state.isActive,
    });
  }

  insertRow(event) {
    let correo = this.correoEmpleado.value;
    let pass = this.contrasenaEmpleado.value;
    let con_pass = this.confirEmpleado.value;
    let pasaporte = this.pasaporteEmpleado.value;
    let dui = this.duiEmpleado.value;
    let numero_empleado = this.numeroEmpleado.value;
    let nombre = this.nombreEmpleado.value;
    let apellido = this.apellidoEmpleado.value;
    let preferencia = this.preferencia.value;
    let centro = this.state.codCosto;
    let area = this.area.value;

    //Registrar en el auth
    if (pass === con_pass) {
      secondaryApp
        .auth()
        .createUserWithEmailAndPassword(correo, pass)
        .then((user) => {
          this.clientesRef.child(user.uid).update({
            apellido: apellido,
            nombre: nombre,
            correo: correo,
            numero_empleado: numero_empleado,
            pasaporte: pasaporte,
            dui: dui,
            centro: centro,
            estado: "Activo",
            socio: store.getState().nodo_empresa,
            subir: false,
            viaje: "desactivo",
            viajeActual: "ninguno",
            preferencia: preferencia,
            areaDesc: area,
            latitud: -89.20134488794466,
            longitud: 13.701950380252162,
          });

          Alert.success("Datos guardados con exito", {
            effect: "genie",
            position: "bottom-right",
            timeout: 2000,
          });

          this.toggleModal();

          secondaryApp.auth().signOut();
        })
        .catch((error) => {
          let msj = error;

          if (error.code === "auth/email-already-in-use") {
            msj =
              "Ya existe una cuenta con la dirección de correo electrónico especificada.";
          } else if (error.code === "auth/invalid-email") {
            msj = "Dirección de correo electronico no valida.";
          } else if (error.code === "auth/weak-password") {
            msj = "La contraseña ingresada no es demasiado fuerte.";
          }

          Alert.error(msj, {
            effect: "genie",
            position: "bottom-right",
            timeout: 2000,
          });
        });
    } else {
      Alert.error("Las contraseñas ingresadas no coinciden", {
        effect: "genie",
        position: "bottom-right",
        timeout: 2000,
      });
    }

    event.preventDefault();
  }

  handleKeyPressNumeros(e) {
    let tecla = e.which;
    let patron = /^[0-9]+$/;
    let tecla_final = String.fromCharCode(tecla);

    let rs = patron.test(tecla_final);

    if (!rs) {
      e.preventDefault();
    }
  }

  handleKeyPressDui(e) {
    let dui = this.duiEmpleado.value;
    let tecla = e.which;

    if (dui.length === 8) {
      if (!(tecla === 45)) {
        e.preventDefault();
      }
    } else {
      let patron = /^[0-9]+$/;

      let tecla_final = String.fromCharCode(tecla);

      let rs = patron.test(tecla_final);

      if (!rs) {
        e.preventDefault();
      }
    }
  }
  //validar el estado del modal
  toggleModalCosto = () => {
    this.setState({
      isActiveCosto: !this.state.isActiveCosto,
    });
  };

  componentWillMount() {
    this.costosRef.on("value", this.gotDataCostos, this.errDataTipos);
    Modal.setAppElement("body");
    let uid = firebase.auth().currentUser.uid;
    this.setState({ empresaUID: uid });
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  componentDidMount() {
    this.costosRef.on("value", this.gotDataCostos, this.errDataTipos);
    document.addEventListener("mousedown", this.handleClickOutside);
    const user = firebase.auth().currentUser;

    this.empresaRef = database.ref().child(`Empresa/${user.uid}`);

    this.empresaRef.once("value", (snapshot) => {
      if (snapshot.exists()) {
        const empresaData = snapshot.val();
        this.setState({ authUser: empresaData.codigo_empresa });
        console.log("Empresa => ", this.state.authUser);
      } else {
        console.log("No se encontró la empresa con ese UID.");
      }
    });
  }

  gotDataCostos = (data) => {
    let Datos = [];
    const Base = data.val();
    if (data.val() !== null) {
      const keys = Object.keys(Base);
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i];
        if (Base[k].empresa === this.state.empresaUID) {
          Datos.push({
            key: k,
            codigo: Base[k].codigo,
            descripcion: Base[k].descripcion,
            responsable: Base[k].responsable,
            area: Base[k].area,
          });
        }
      }
      this.setState({ Costos: Datos });
    }
  };
  errDataSocios = (err) => {
    console.log(err);
  };

  btnCostosFormatter(cell, row) {
    return (
      <button
        className="btn btn-success btn-sm"
        onClick={() => {
          this.handleClickCostos(row);
        }}
      >
        Seleccionar
      </button>
    );
  }

  handleClickCostos = (rowKey) => {
    this.state.nom = rowKey.codigo;
    this.state.codCosto = rowKey.key;

    this.toggleModalCosto();
  };
  toggleModal() {
    this.setState({ isActive: !this.state.isActive });
  }

  toggleModalUpload() {
    this.setState({ isModalOpenUpload: !this.state.isModalOpenUpload });
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  handleClickOutside = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ isOpen: false });
    }
  };

  downloadTemplate = () => {
    // Definir las columnas del archivo Excel
    const columnsPlantilla = [
      {
        nombre: "",
        apellido: "",
        correo: "",
        password: "",
        numero_empleado: "",
        pasaporte: "",
        dui: "",
        codigo_centro_costo: "",
        areaDesc: "",
      },
    ];

    // Crear una hoja de cálculo desde los datos
    const worksheet = XLSX.utils.json_to_sheet(columnsPlantilla, {
      header: [
        "nombre",
        "apellido",
        "correo",
        "password",
        "numero_empleado",
        "pasaporte",
        "dui",
        "codigo_centro_costo",
        "areaDesc",
      ],
    });

    // Crear un libro de trabajo y agregar la hoja
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Plantilla");

    // Generar el archivo Excel y convertirlo a un Blob
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Crear un enlace y descargar el archivo
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = "plantilla-empleados.xlsx";
    link.click();
    URL.revokeObjectURL(url);
  };

  downloadData = () => {
    console.log("EMPLEADOS => ", this.empleadosColect);

    if (!this.empleadosColect) {
      alert("No se puede acceder a la referencia de la base de datos.");
      return;
    }

    this.empleadosColect.once("value", (snapshot) => {
      const empleadodata = snapshot.val();

      if (!empleadodata) {
        alert("No hay datos disponibles para descargar.");
        return;
      }

      const empleados = Object.keys(empleadodata).map((key) => ({
        _ID: key,
        nombre: empleadodata[key].nombre || "",
        apellido: empleadodata[key].apellido || "",
        correo: empleadodata[key].correo || "",
        numero_empleado: empleadodata[key].numero_empleado || "",
        pasaporte: empleadodata[key].pasaporte || "",
        dui: empleadodata[key].dui || "",
        codigo_centro_costo: empleadodata[key].centro || "",
        areaDesc: empleadodata[key].areaDesc || "",
      }));

      console.log("EMPPLEADO DATA S1 => ", empleados);

      // Crear la hoja de cálculo principal
      const worksheet = XLSX.utils.json_to_sheet(
        empleados.map(({ _ID, ...rest }) => rest)
      );

      console.log("EMPPLEADO DATA S2 => ", empleados);
      // Crear una hoja separada para los IDs
      const worksheetIDs = XLSX.utils.aoa_to_sheet(
        empleados.map((empleado) => [empleado._ID])
      );

      console.log(worksheetIDs);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Empleados");
      XLSX.utils.book_append_sheet(workbook, worksheetIDs, "IDs");

      console.log("WORKBOOK S1 => ", workbook);

      // Ocultar la hoja de IDs
      if (!workbook.Workbook) workbook.Workbook = { Sheets: [] };
      workbook.Workbook.Sheets = workbook.Workbook.Sheets || [];
      workbook.Workbook.Sheets[1] = { Hidden: 1 };
      console.log("WORKBOOK S2 => ", workbook);
      // Convertir a un archivo Excel y descargarlo
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Crear enlace de descarga
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "empleados.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  render() {
    const { authUser } = this.state;
    return (
      <div>
        <button className="btn btn-primary mr-2" onClick={this.toggleModal}>
          <span className="glyphicon glyphicon-plus"> </span> Nuevo
        </button>
        {authUser === "Avianca" && (
            <React.Fragment>
              <button
                className="btn btn-success  mr-2"
                onClick={this.toggleModalUpload}
              >
                <span className="glyphicon glyphicon-plus"> </span> Cargar
                Empleados
              </button>

              <div className="dropdown" ref={this.dropdownRef}>
                <button className="btn btn-info" onClick={this.toggleDropdown}>
                  <span className="glyphicon glyphicon-plus"> </span> Descargar
                </button>
                {this.state.isOpen && (
                  <div className="dropdown-menu show">
                    <button
                      className="dropdown-item"
                      onClick={this.downloadTemplate}
                    >
                      Plantilla
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={this.downloadData}
                    >
                      Archivo con Datos
                    </button>
                  </div>
                )}
              </div>
            </React.Fragment>
          )}

        <Modal_Upload_Data
          isActive={this.state.isModalOpenUpload}
          toggleModal={this.toggleModalUpload}
          socio={this.props.socio}
        />

        <Modal
          isOpen={this.state.isActive}
          onRequestClose={this.toggleModal}
          style={customStyles}
        >
          <form method="POST" action="" onSubmit={this.insertRow}>
            <h3>Agregar Empleado</h3>

            <hr />
            <div className="form-group">
              <label htmlFor="nombre">Nombre</label>
              <input
                type="text"
                className="form-control"
                name="nombre"
                placeholder="Nombre"
                required
                autoComplete="off"
                ref={(input) => {
                  this.nombreEmpleado = input;
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="apellido">Apellido</label>
              <input
                type="text"
                className="form-control"
                name="apellido"
                placeholder="Apellido"
                required
                autoComplete="off"
                ref={(input) => {
                  this.apellidoEmpleado = input;
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="correo">Correo:</label>
              <input
                type="text"
                className="form-control"
                name="correo"
                placeholder="Correo"
                required
                autoComplete="off"
                ref={(input) => {
                  this.correoEmpleado = input;
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="contrasena">Contraseña</label>
              <input
                type="password"
                className="form-control"
                name="contrasena"
                placeholder="Contraseña"
                required
                autoComplete="off"
                ref={(input) => {
                  this.contrasenaEmpleado = input;
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirmar-contrasena">Contraseña</label>
              <input
                type="password"
                className="form-control"
                name="confirmar-contrasena"
                placeholder="Confirmar contraseña"
                required
                autoComplete="off"
                ref={(input) => {
                  this.confirEmpleado = input;
                }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="numero_empleado">Numero de empleado:</label>
              <input
                type="text"
                className="form-control"
                name="numero_empleado"
                placeholder="Numero de empleado"
                required
                autoComplete="off"
                ref={(input) => {
                  this.numeroEmpleado = input;
                }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="dui">Dui:</label>
              <input
                type="text"
                className="form-control"
                name="dui"
                placeholder="Dui"
                required
                autoComplete="off"
                ref={(input) => {
                  this.duiEmpleado = input;
                }}
                onKeyPress={this.handleKeyPressDui}
                maxLength="10"
                minLength="10"
              />
            </div>

            <div className="form-group">
              <label htmlFor="pasaporte">Pasaporte:</label>
              <input
                type="text"
                className="form-control"
                name="pasaporte"
                placeholder="Pasaporte"
                required
                autoComplete="off"
                ref={(input) => {
                  this.pasaporteEmpleado = input;
                }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="nombre">Area</label>
              <input
                type="text"
                className="form-control"
                name="nombre"
                placeholder="Area"
                required
                autoComplete="off"
                ref={(input) => {
                  this.area = input;
                }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="cento">Centro Costo</label>
              <input
                type="text"
                className="form-control"
                ref={(input) => {
                  this.cod = input;
                }}
                readOnly="readonly"
                required
                autoComplete="off"
                onClick={this.toggleModalCosto}
                placeholder="Ejile una Centro de costos"
                value={this.state.nom}
              />
            </div>

            <div className="form-group">
              <label htmlFor="preferencia">Preferencia:</label>
              <select
                className="form-control"
                ref={(input) => {
                  this.preferencia = input;
                }}
              >
                <option>Taxi</option>
                <option>Microbus</option>
                <option>Privado</option>
                <option>Todos</option>
              </select>
            </div>

            <button className="btn btn-primary buttons" type="submit">
              Guardar
            </button>
          </form>
          <button
            className="btn btn-default buttons btnmargin"
            onClick={this.toggleModal}
          >
            Cerrar
          </button>
        </Modal>

        <Modal
          isOpen={this.state.isActiveCosto}
          onRequestClose={this.toggleModalCosto}
          style={customStyles}
        >
          <h4>Selecciona un Centro de costos</h4>
          <hr />

          <BootstrapTable
            data={this.state.Costos}
            ref="table"
            pagination={true}
            search={true}
            hover
          >
            <TableHeaderColumn
              dataField="key"
              isKey={true}
              dataSort={true}
              hidden
            >
              Nombre
            </TableHeaderColumn>
            <TableHeaderColumn dataField="codigo" dataSort={true}>
              Codigo
            </TableHeaderColumn>
            <TableHeaderColumn dataField="area" dataSort={true}>
              Area
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="edit"
              dataAlign="center"
              dataFormat={this.btnCostosFormatter.bind(this)}
            >
              Seleccionar
            </TableHeaderColumn>
          </BootstrapTable>
        </Modal>
      </div>
    );
  }
}

export default Modal_empleados;



// WEBPACK FOOTER //
// ./src/Components/Emp_Empresas/Modal_empleados.js